import { useQuery } from '@apollo/client';
import { useCallback } from 'react';
import { useUser } from '../../hooks/useUser';
import { GET_CURATED_LOOKS_QUERY } from './curatedLooks.rest';

const DEFAULT_PER_PAGE = 10;

export const useCuratedLooks = () => {
  const {
    user: { accessToken, isLoggedIn }
  } = useUser();

  const {
    data,
    loading,
    error,
    fetchMore: fetchMoreFn
  } = useQuery(GET_CURATED_LOOKS_QUERY, {
    variables: {
      page: 1,
      perPage: DEFAULT_PER_PAGE
    },
    notifyOnNetworkStatusChange: true,
    skip: !isLoggedIn || !accessToken
  });

  const fetchMore = useCallback(
    (page: number) => {
      fetchMoreFn({
        variables: {
          page,
          perPage: DEFAULT_PER_PAGE
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;

          return {
            curatedLooks: {
              __typename: 'RestCuratedLooksResponse',
              data: [...prev.curatedLooks.data, ...fetchMoreResult.curatedLooks.data],
              meta: fetchMoreResult.curatedLooks.meta
            }
          };
        }
      });
    },
    [fetchMoreFn]
  );

  return {
    curatedLooks: data?.curatedLooks?.data ?? [],
    pagination: data?.curatedLooks?.meta?.pagination,
    loading,
    error,
    fetchMore
  };
};
